var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:'icon-block ' + _vm.getExtension(_vm.params)},[_c('font-awesome-icon',{staticClass:"icon",attrs:{"size":"sm","icon":['fas', 'file-' + _vm.getExtension(_vm.params)]}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }